// src/app/shared/components/declaration-pdf/declaration-pdf.component.ts
import { Component, Input } from '@angular/core';
import { DeclarationPdfService } from 'src/app/core/services/declaration-pdf.service';

@Component({
  selector: 'app-declaration-pdf',
  templateUrl: './declaration-pdf.component.html',
  styleUrls: ['./declaration-pdf.component.scss'],
})
export class DeclarationPdfComponent {
  @Input() lot: any;
  @Input() deliveryAddress: any;
  isLoading = false;

  constructor(private pdfService: DeclarationPdfService) { }

  download() {
    if (!this.lot || !this.deliveryAddress) return;

    this.isLoading = true;
    setTimeout(async () => {
      try {
        const userRaw = localStorage.getItem('user');
        const user = userRaw ? JSON.parse(userRaw) : null;
        await this.pdfService.fillAndDownloadPdf(this.lot, this.deliveryAddress, user);
      } catch (error) {
        console.error('Erro ao gerar declaração de conteúdo:', error);
      } finally {
        this.isLoading = false;
      }
    }, 300);
  }
}
